<script lang="ts">
  import { onMount } from "svelte";
  import { DossierStatusesService } from "../../services/dossier-statuses.service";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import SearchDropdown from "../Form/Fields/Dropdown/SearchDropdown.svelte";

  export let placeholder: string = "";
  export let required: boolean = false;
  export let clearVisible: boolean = false;
  export let filterVisible: boolean = true;
  export let name: string = "";
  export let value: number = null;

  let items: IDropdownItem[] = [];

  function onFilter(event: CustomEvent) {
    let filter: string = event.detail;
    search(filter);
  }

  async function search(filter: string) {
    let selfId = !!value ? value : 0;
    let values = await DossierStatusesService.searchDossierStatusCombo(
      selfId,
      filter
    );
    items = values.payload || [];
  }

  onMount(() => search(""));
</script>

<SearchDropdown
  {placeholder}
  {required}
  {clearVisible}
  {filterVisible}
  {name}
  {items}
  bind:value
  on:filter={onFilter}
/>
